export const GET_DATA = 'getComponentData';

export const MUT_DATA = 'setComponentData';
export const MUT_RESET = 'resetComponentsData';
